import { ConfiguratorRenewalInformation } from '@models';
import { createAction, props } from '@ngrx/store';

export enum RenewalActions {
  UpdateFlowRenewalInformation = '[Flow Data Renewal] Renewal Information',
}

export const UpdateFlowRenewalInformation = createAction(
  RenewalActions.UpdateFlowRenewalInformation,
  props<{ data: ConfiguratorRenewalInformation }>()
);
